import {
    Truck, Warehouse, PackageOpen, Boxes, Recycle, Network, Layers, Workflow,
    ShieldCheck, MapPin, Wrench, Factory, Zap, Cog, Tractor, CarFront,
    Satellite, Activity, FileBarChart, ServerCog, Radio, Gauge, Route,
    BarChart3, Clock, Users, Building2, Phone, Mail, ArrowRight, ArrowUpRight,
    CheckCircle2, ChevronRight, Linkedin, Twitter, Facebook, Send, Sparkles,
    BadgeCheck, Anchor, Compass, PackageCheck,
} from "lucide-react";

const map = {
    Truck, Warehouse, PackageOpen, Boxes, Recycle, Network, Layers, Workflow,
    ShieldCheck, MapPin, Wrench, Factory, Zap, Cog, Tractor, CarFront,
    Satellite, Activity, FileBarChart, ServerCog, Radio, Gauge, Route,
    BarChart3, Clock, Users, Building2, Phone, Mail, ArrowRight, ArrowUpRight,
    CheckCircle2, ChevronRight, Linkedin, Twitter, Facebook, Send, Sparkles,
    BadgeCheck, Anchor, Compass, PackageCheck,
};

export function Icon({ name, className = "h-5 w-5", strokeWidth = 1.5 }) {
    const Cmp = map[name] || Sparkles;
    return <Cmp className={className} strokeWidth={strokeWidth} />;
}

export default Icon;
